const initialState = {
  articles: null, // media object
  currentArticle: null,
  isOpen: false,
  area: null
};

export const articleViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_ARTICLE_VIEWER": {
      return initialState;
    }
    case "OPEN_ARTICLE_VIEWER": {
      return { ...state, ...action.viewer };
    }
    case "SET_CURRENT_ARTICLE_VIEWER": {
      return { ...state, currentArticle: action.media };
    }
    case "FETCH_SINGLE_ARTICLE_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        currentArticle: { ...data[0] }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/article-viewer.js